<template>
  <b-modal
    id="confirm-zone-change-modal"
    title="Change Zone?"
    ok-title="Confirm"
    cancel-title="Cancel"
    centered
    size="md"
    hide-footer
    @ok="onConfirmZoneChange"
  >
    <div class="text-center p-1">
      <p class="mb-2">
        Are you sure you want to change the zone? <br>
        <strong>This will reset all team progress.</strong>
      </p>
      <div class="d-flex align-items-center justify-content-center gap-3">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="$bvModal.hide('confirm-zone-change-modal')"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="submitting"
          variant="danger"
          @click="onConfirmZoneChange"
        >
          <BSpinner
            v-if="submitting"
            small
          />
          Confirm
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BSpinner, BModal, BButton } from 'bootstrap-vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BSpinner,
    BButton,
    BModal,
  },
  props: {
    newZone: {
      type: String,
      required: true,
    },
    teamId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit, root }) {
    const submitting = ref(false)
    const onConfirmZoneChange = async () => {
      submitting.value = true
      try {
        await axiosIns.patch(`/teams/${props.teamId}`, {
          zone: props.newZone,
        })
        root.$bvModal.hide('confirm-zone-change-modal')
        emit('refresh')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      onConfirmZoneChange,
    }
  },
}
</script>
